import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const inputLabel = ({ palette }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiInputLabel"] => ({
    root: {
        color: palette.coolGrey,
    },
    formControl: {
        transform: "translate(0, 2.2rem) scale(1)",
    },
    asterisk: {
        marginLeft: "-0.3rem",
    },
    shrink: {
        transform: "translate(0, 0) scale(0.875)",
    },
});

export default inputLabel;
